export default {
  steps: {
    0: {
      title: 'Word een stamgast',
      description: 'Bekijk je bestelgeschiedenis en herbestel met één tik.',
    },
    1: {
      title: 'Verdien beloningen',
      description: 'Houd je punten bij en wissel opgespaarde beloningen in vanuit je portemonnee.',
    },
    2: {
      title: 'Vooruit bestellen',
      description: 'Vind je dichtstbijzijnde locatie en bestel sneller dan ooit.',
    },
  },
  buttons: {
    skip: 'Overslaan',
  },
};
